import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router, NavigationEnd } from '@angular/router';
import { GlobalService } from '../services/global.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap'

import { UserService } from '../services/user.service';
import { isPlatformServer } from '@angular/common';
declare let pendo: any;

//const authUrl = 'https://authdev3.hvsfinancial.com/Token'; // UAT
const authUrl = 'https://auth.hvsfinancial.com/Token'; // Prod
//const authUrl = 'http://authdev.hvsfinancial.com.loc/Token';
//const authUrl = 'https://authpentest.hvsfinancial.com/Token';
//const apiUrl = 'https://apidev2.hvsfinancial.com//api/'; // HVS UAT
// const apiUrl = 'https://apiuat2.hvsfinancial.com/api/'; // Nationwide UAT
//const apiUrl = 'http://api.hvsfinancial.com.loc/api/';
//const apiUrl = 'https://hvsportalpentestsvc.hvsfinancial.com/api/';
// const apiUrl = 'https://apidev3.hvsfinancial.com/api/';
const apiUrl ='https://portal-api.hvsfinancial.com/api/' // Prod2 - redesign

@Injectable()
export class AuthService {
  constructor(private router: Router, private http: Http, private userService: UserService, private globalService: GlobalService) { }
  
  //pendo;
  window;

  login(username: string, password: string) {
    let body = `username=${username}&password=${password}&grant_type=password`;
    let test = { UserID: '0' };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
    
    let options = { withCredentials: true };

    let user;

    return this.http.post(authUrl, body)
      .map((response: Response) => {
        let resp = response.json(), bearer;

        if (resp && resp.access_token) {
          bearer = resp.access_token;

          headers.append('Authorization', `bearer ${bearer}`);
          options = new RequestOptions({headers})

          test.UserID = resp.userID;

          this.userService.setAuthentication(resp);
          // console.log(resp);
          
          return bearer;
        }

        return;
      })
      .flatMap(() => this.http.get(apiUrl + 'OAuth/validate', options).map((response: Response) => {
        let resp = response.json();
        if(resp){
          localStorage.setItem('crmIntegrations', JSON.stringify(false));//resp));
        }
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetUser', JSON.stringify(test), options).map((response: Response) => {
        let resp = response.json();
        user = resp;
        this.userService.setUserInformation(resp);
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/AllowMicrotransactions', JSON.stringify(test), options).map((response: Response) => {
        let resp = response.json();
        if(resp){
          localStorage.setItem('allowedMicrotransactions', JSON.stringify(false));//resp));
        }
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrganization', JSON.stringify({ ID: user.OrganizationID}), options).map((response: Response) => {
        let resp = response.json();
        
        localStorage.setItem('logoPhotoPath', resp.LogoPath);
        localStorage.setItem('parentID', resp.ParentID);
        localStorage.setItem('orgID', resp.ID);

         //PENDO HERE
         this.http.get(apiUrl + "/IsAlive/CheckAPIService", {}).subscribe(r => {
          pendo.initialize({
            visitor: {
                //Pass user ID
                id: test.UserID
                //TODO: add additional info from user here for tracking/analytics
            },
            account: {
                //Pass Org ID
                id: user.OrganizationID
            }
          });
        });
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrgApplications', JSON.stringify({ ID: (localStorage.getItem('parentID') != '0') ? localStorage.getItem('parentID') : localStorage.getItem('orgID')}), options).map((response: Response) => {
        let resp = response.json();        
        if(resp.length > 0){
          console.log('Org Apps', resp);
          localStorage.setItem('orgApps', JSON.stringify(resp));
        }
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrgFeatures', JSON.stringify({ ID: (localStorage.getItem('parentID') != '0') ? localStorage.getItem('parentID') : localStorage.getItem('orgID')}), options).map((response: Response) => {
        let resp = response.json();
        //if array is empty; allow all
        this.globalService.orgAccess = resp;
        console.log('features', resp);
        if(resp.length > 0){
          for(let value of resp){

            if(value.FeatureTypeID == 1){
              this.globalService.featRiskTolerance = true;
            }else if(value.FeatureTypeID === 2){
              this.globalService.featHealthCare = true;
            }else if(value.FeatureTypeID == 3){
              this.globalService.featSocialSecurity = true;
            }else if(value.FeatureTypeID == 4){
              this.globalService.featLongTermCare = true;
            }else if(value.FeatureTypeID == 5){
              this.globalService.featTitan = true;
            }else if(value.FeatureTypeID == 6 
              && (localStorage.getItem('parentID') == '0') 
              && (localStorage.getItem('roleId') == '2')){
              this.globalService.featHomeOffice = true;
            }else if(value.FeatureTypeID == 7){
              this.globalService.featMeansTesting = true;
            }else if(value.FeatureTypeID == 8){
              this.globalService.featCombinedHealthcareLTC = true;
            }else if(value.FeatureTypeID == 9){
              //console.log('feat fudning 1');
              this.globalService.featFunding = true;
            }else if(value.FeatureTypeID == 10){
              this.globalService.featExpressHealthcare = true;
            }else if(value.FeatureTypeID == 11){
              this.globalService.featApplications = true;
            }else if(value.FeatureTypeID == 12){
              this.globalService.featQuickReports = true;
            }else if(value.FeatureTypeID == 14){
              this.globalService.featAdditionalQuestions = true;
            }else if(value.FeatureTypeID == 16){
              this.globalService.featAbilityToDelete = true;
            }else if(value.FeatureTypeID == 17){
              this.globalService.featLTCMapReporting = true;
            }else if(value.FeatureTypeID == 18){
              // this.globalService.featRetirementSuite = true;
            }else if(value.FeatureTypeID == 19){
              this.globalService.featChatBot = true;
            }

          }
          
        }else{
          //console.log('feat fudning 2');
          //not in table => lets preset the basic tool/default
          this.globalService.featHealthCare = true;
          this.globalService.featLongTermCare = true;
          this.globalService.featSocialSecurity = true;
          this.globalService.featTitan = true;      
          this.globalService.featMeansTesting = true;   
          this.globalService.featCombinedHealthcareLTC = true;  
          this.globalService.featFunding = true;
          this.globalService.featExpressHealthcare = true;
          this.globalService.featApplications = true;
          this.globalService.featQuickReports = true;

          //these are not part of the basics
          this.globalService.featRiskTolerance = false;
          this.globalService.featHomeOffice = false;   
          
          this.globalService.featAdditionalQuestions = false;
          this.globalService.featAbilityToDelete = false;
          this.globalService.featLTCMapReporting = false
          this.globalService.featRetirementSuite = false;
          this.globalService.featChatBot = true;
        }

        this.globalService.hasSetFeatures = true;      

        localStorage.setItem('featRiskTolerance', JSON.stringify(this.globalService.featRiskTolerance || false));
        localStorage.setItem('featHomeOffice', JSON.stringify(this.globalService.featHomeOffice || false));
        localStorage.setItem('featMeansTesting', JSON.stringify(this.globalService.featMeansTesting || false));
        localStorage.setItem('featLongTermCare', JSON.stringify(this.globalService.featLongTermCare || false));
        localStorage.setItem('featSocialSecurity', JSON.stringify(this.globalService.featSocialSecurity || false));
        localStorage.setItem('featHealthCare', JSON.stringify(this.globalService.featHealthCare || false));
        localStorage.setItem('featCombinedHealthcareLTC', JSON.stringify(this.globalService.featCombinedHealthcareLTC || false));
        localStorage.setItem('featFunding', JSON.stringify(this.globalService.featFunding || false));
        localStorage.setItem('featApplications', JSON.stringify(this.globalService.featApplications || false));
        localStorage.setItem('featExpressHealthcare', JSON.stringify(this.globalService.featExpressHealthcare || false));
        localStorage.setItem('featQuickReports', JSON.stringify(this.globalService.featQuickReports || false));

        localStorage.setItem('featAdditionalQuestions', JSON.stringify(this.globalService.featAdditionalQuestions || false));
        localStorage.setItem('featAbilityToDelete', JSON.stringify(this.globalService.featAbilityToDelete || false));
        localStorage.setItem('featLTCMapReporting', JSON.stringify(this.globalService.featLTCMapReporting || false));

        localStorage.setItem('featRetirementSuite', JSON.stringify(this.globalService.featRetirementSuite || false));
        localStorage.setItem('featChatBot', JSON.stringify(this.globalService.featChatBot || false));
        //console.log('funding stuff', JSON.stringify(this.globalService.featFunding || false));
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrganization', JSON.stringify({ ID: localStorage.getItem('parentID')}), options).map((response: Response) => {
        let resp = response.json();
        
        if (resp && localStorage.getItem('logoPhotoPath') == 'null') {
          localStorage.setItem('logoPhotoPath', resp.LogoPath);
        }
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetYearlyValues', '', options).map((response: Response) => {
        let resp = response.json();
        localStorage.setItem('yearlyValues', JSON.stringify(resp.fourYearCOLAs));
        localStorage.setItem('historicalCOLAs', JSON.stringify(resp.historyicalCOLAs));
      }));
  }

  loginSSO() {
    
    let test = { UserID: '0' };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
    headers.append('Authorization', `bearer ${localStorage.getItem('bearer')}`);
    let options = new RequestOptions({headers})

    let user;

    console.log('headers attached', headers);

    return this.http.post(apiUrl + 'CoreOrganization/GetUserSSO', JSON.stringify(test), options).map((response: Response) => {
        let resp = response.json();
        user = resp;
        test.UserID = resp.ID;
        //var body {};
        //this.userService.setAuthentication(body);
        localStorage.setItem('roleId', resp.RoleID);
        localStorage.setItem('userId', resp.ID);
        
        this.userService.setUserInformation(resp);
      })
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrganization', JSON.stringify({ ID: user.OrganizationID}), options).map((response: Response) => {
        let resp = response.json();
        
        localStorage.setItem('logoPhotoPath', resp.LogoPath);
        localStorage.setItem('parentID', resp.ParentID);
        localStorage.setItem('orgID', resp.ID);

         //PENDO HERE
         this.http.get(apiUrl + "/IsAlive/CheckAPIService", {}).subscribe(r => {
          pendo.initialize({
            visitor: {
                //Pass user ID
                id: test.UserID
                //TODO: add additional info from user here for tracking/analytics
            },
            account: {
                //Pass Org ID
                id: user.OrganizationID
            }
          });
        });
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrgApplications', JSON.stringify({ ID: (localStorage.getItem('parentID') != '0') ? localStorage.getItem('parentID') : localStorage.getItem('orgID')}), options).map((response: Response) => {
        let resp = response.json();        
        if(resp.length > 0){
          console.log('Org Apps', resp);
          localStorage.setItem('orgApps', JSON.stringify(resp));
        }
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrgFeatures', JSON.stringify({ ID: (localStorage.getItem('parentID') != '0') ? localStorage.getItem('parentID') : localStorage.getItem('orgID')}), options).map((response: Response) => {
        let resp = response.json();
        //if array is empty; allow all
        this.globalService.orgAccess = resp;
        console.log('features', resp);
        if(resp.length > 0){
          for(let value of resp){

            if(value.FeatureTypeID == 1){
              this.globalService.featRiskTolerance = true;
            }else if(value.FeatureTypeID === 2){
              this.globalService.featHealthCare = true;
            }else if(value.FeatureTypeID == 3){
              this.globalService.featSocialSecurity = true;
            }else if(value.FeatureTypeID == 4){
              this.globalService.featLongTermCare = true;
            }else if(value.FeatureTypeID == 5){
              this.globalService.featTitan = true;
            }else if(value.FeatureTypeID == 6 
              && (localStorage.getItem('parentID') == '0') 
              && (localStorage.getItem('roleId') == '2')){
              this.globalService.featHomeOffice = true;
            }else if(value.FeatureTypeID == 7){
              this.globalService.featMeansTesting = true;
            }else if(value.FeatureTypeID == 8){
              this.globalService.featCombinedHealthcareLTC = true;
            }else if(value.FeatureTypeID == 9){
              //console.log('feat fudning 1');
              this.globalService.featFunding = true;
            }else if(value.FeatureTypeID == 10){
              this.globalService.featExpressHealthcare = true;
            }else if(value.FeatureTypeID == 11){
              this.globalService.featApplications = true;
            }else if(value.FeatureTypeID == 12){
              this.globalService.featQuickReports = true;
            }else if(value.FeatureTypeID == 14){
              this.globalService.featAdditionalQuestions = true;
            }else if(value.FeatureTypeID == 16){
              this.globalService.featAbilityToDelete = true;
            }else if(value.FeatureTypeID == 17){
              this.globalService.featLTCMapReporting = true;
            }else if(value.FeatureTypeID == 18){
              // this.globalService.featRetirementSuite = true;
            }else if(value.FeatureTypeID == 19){
              this.globalService.featChatBot = true;
            }

          }
          
        }else{
          //console.log('feat fudning 2');
          //not in table => lets preset the basic tool/default
          this.globalService.featHealthCare = true;
          this.globalService.featLongTermCare = true;
          this.globalService.featSocialSecurity = true;
          this.globalService.featTitan = true;      
          this.globalService.featMeansTesting = true;   
          this.globalService.featCombinedHealthcareLTC = true;  
          this.globalService.featFunding = true;
          this.globalService.featExpressHealthcare = true;
          this.globalService.featApplications = true;
          this.globalService.featQuickReports = true;
          
          //these are not part of the basics
          this.globalService.featRiskTolerance = false;
          this.globalService.featHomeOffice = false;     

          this.globalService.featAdditionalQuestions = false;
          this.globalService.featAbilityToDelete = false;
          this.globalService.featLTCMapReporting = false;
          this.globalService.featChatBot = false;
        }

        this.globalService.hasSetFeatures = true;         

        localStorage.setItem('featRiskTolerance', JSON.stringify(this.globalService.featRiskTolerance || false));
        localStorage.setItem('featHomeOffice', JSON.stringify(this.globalService.featHomeOffice || false));
        localStorage.setItem('featMeansTesting', JSON.stringify(this.globalService.featMeansTesting || false));
        localStorage.setItem('featLongTermCare', JSON.stringify(this.globalService.featLongTermCare || false));
        localStorage.setItem('featSocialSecurity', JSON.stringify(this.globalService.featSocialSecurity || false));
        localStorage.setItem('featHealthCare', JSON.stringify(this.globalService.featHealthCare || false));
        localStorage.setItem('featCombinedHealthcareLTC', JSON.stringify(this.globalService.featCombinedHealthcareLTC || false));
        localStorage.setItem('featFunding', JSON.stringify(this.globalService.featFunding || false));
        localStorage.setItem('featApplications', JSON.stringify(this.globalService.featApplications || false));
        localStorage.setItem('featExpressHealthcare', JSON.stringify(this.globalService.featExpressHealthcare || false));
        localStorage.setItem('featQuickReports', JSON.stringify(this.globalService.featQuickReports || false));

        localStorage.setItem('featAdditionalQuestions', JSON.stringify(this.globalService.featAdditionalQuestions || false));
        localStorage.setItem('featAbilityToDelete', JSON.stringify(this.globalService.featAbilityToDelete || false));
        localStorage.setItem('featLTCMapReporting', JSON.stringify(this.globalService.featLTCMapReporting || false));
        localStorage.setItem('featChatBot', JSON.stringify(this.globalService.featChatBot || false));
        //console.log('funding stuff', JSON.stringify(this.globalService.featFunding || false));
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrganization', JSON.stringify({ ID: localStorage.getItem('parentID')}), options).map((response: Response) => {
        let resp = response.json();
        
        if (resp && localStorage.getItem('logoPhotoPath') == 'null') {
          localStorage.setItem('logoPhotoPath', resp.LogoPath);
        }
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetYearlyValues', '', options).map((response: Response) => {
        let resp = response.json();
        localStorage.setItem('yearlyValues', JSON.stringify(resp.fourYearCOLAs));
        localStorage.setItem('historicalCOLAs', JSON.stringify(resp.historyicalCOLAs));
      }));
  }
  
  public logout() {
    /* if(localStorage.getItem('bearer') != null){
      let headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
      headers.append('Authorization', `bearer ${localStorage.getItem('bearer')}`);
      let options = new RequestOptions({headers})
      return this.http.post(apiUrl + 'CoreOrganization/UpdateUser', JSON.stringify({}), options).map((response: Response) => {
          return response;      
      })
      .subscribe(data => {
        //clear out local storage data 
        console.log('auth service logged you out 02');
        localStorage.clear();   
      });
    } else {
      console.log('auth service logged you out 01');
      localStorage.clear();
    } */

    console.log('auth service logged you out');
    localStorage.clear();

    //window.location.href = "";
    //this.router.navigateByUrl('login');
    //this.globalService.SignOut();
  }
}
